import React, { useMemo, useState } from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";
import { FiHeart } from "react-icons/fi";

function formatGbp(price) {
  const n = Number(price);
  if (Number.isNaN(n)) return price;
  return n % 1 === 0 ? String(Math.round(n)) : n.toFixed(0);
}

function colorLine(colors) {
  if (!colors || !colors.length) return "";
  return colors.join(" / ");
}

function Shop() {
  const [sortBy, setSortBy] = useState("default");

  const sortedProducts = useMemo(() => {
    const list = [...productData];
    switch (sortBy) {
      case "price-asc":
        return list.sort((a, b) => Number(a.price) - Number(b.price));
      case "price-desc":
        return list.sort((a, b) => Number(b.price) - Number(a.price));
      case "name-asc":
        return list.sort((a, b) => a.name.localeCompare(b.name));
      default:
        return list.sort((a, b) => a.id - b.id);
    }
  }, [sortBy]);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop-page">
      <Header />

      <main className="shop-main" id="main-content">
        <div className="shop-inner">
          <header className="shop-hero">
            <h1 className="shop-hero__title">WOMEN&apos;S SHOP ALL</h1>
            <p className="shop-hero__sub">
              Shop must-have pieces, from everyday essentials to bold
              statements.
            </p>
            <p className="shop-hero__count">{sortedProducts.length} Products</p>
          </header>

          <div className="shop-toolbar">
            <label htmlFor="shop-sort" className="shop-toolbar__label">
              Sort by
            </label>
            <div className="shop-toolbar__select-wrap">
              <select
                id="shop-sort"
                className="shop-toolbar__select"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="default">Featured</option>
                <option value="price-asc">Price: Low to High</option>
                <option value="price-desc">Price: High to Low</option>
                <option value="name-asc">Name: A–Z</option>
              </select>
              <span className="shop-toolbar__chevron" aria-hidden>
                ∨
              </span>
            </div>
          </div>

          <ul className="shop-grid">
            {sortedProducts.map((p) => (
              <li key={p.id} className="shop-grid__cell">
                <article className="shop-card">
                  <Link
                    onClick={toTop}
                    to={`/shopDetails/${p.id}`}
                    className="shop-card__link"
                  >
                    <div className="shop-card__media">
                      <img
                        src={p.image}
                        alt={p.name}
                        className="shop-card__img"
                        loading="lazy"
                        decoding="async"
                      />
                      <button
                        type="button"
                        className="shop-card__fav"
                        aria-label="Add to favorites"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        <FiHeart />
                      </button>
                    </div>
                    {p.isBestSeller ? (
                      <span className="shop-card__badge">BEST SELLER</span>
                    ) : null}
                    <h2 className="shop-card__name">{p.name}</h2>
                    <p className="shop-card__color">{colorLine(p.colors)}</p>
                    <p className="shop-card__price">${formatGbp(p.price)}</p>
                  </Link>
                </article>
              </li>
            ))}
          </ul>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Shop;
